const ar = {
  Signin: "تسجيل الدخول",
  Signup: "إنشاء حساب",
  Setting: "الإعدادات",
  "Contact Us Preview": "اتصل بنا معاينة",
  "About Us Preview": "معلومات عنا معاينة",
  "Home Preview": "معاينة الصفحة الرئيسية",
  "Features Preview": "معاينة الميزات",
  "Get Started": "ابدأ الآن",
  "Image Uploaded": "تم تحميل الصورة",
  "Drag & Drop files or Browse": "اسحب وأفلت الملفات أو تصفح",
  Preview: "معاينة",
  Cancel: "إلغاء",
  "Save Changes": "حفظ الكل",
  "Features that live up to your taste and enable you to work":
    "الميزات التي تلبي ذوقك وتمكنك من العمل",
  "With a few clicks, you will have launched your electronic identity in the Internet space, with an unprecedented quality that has been meticulously developed to meet the most important details.":
    "ببضع نقرات فقط، ستكون قد أطلقت هويتك الإلكترونية في فضاء الإنترنت، بجودة غير مسبوقة تم تطويرها بدقة متناهية لتلبي أهم التفاصيل.",
  Name: "الاسم",
  Email: "البريد الإلكتروني",
  Message: "الرسالة",
  "Send Message": "",
  "Add Social Media": "أضف وسيلة تواصل اجتماعي",
  Add: "أضف",
  "Add Home Link": "أضف رابط الصفحة الرئيسية",
  "Add Quick Link": "أضف رابط سريع",
  "Upload Logo": "تحميل الشعار",
  Label: "التسمية",
  URL: "الرابط",
  "Quick Link Label": "تسمية الرابط السريع",
  "Home Link Label": "تسمية رابط الصفحة الرئيسية",
  "New Home Link": "رابط صفحة رئيسية جديد",
  "Link Label": "تسمية الارتباط",
  "Link URL": "عنوان URL للرابط",
  Home: "بيت",
  "Quick Links": "روابط سريعة",
  Address: "عنوان",
  "3041 Alasaker St an nuzha Riyadh": "3041 شارع العساكر، النزهة، الرياض",
  "Billed Monthly":"الفاتورة الشهرية",
  "Billed Yearly" :"تتم الفاتورة سنويًا",
  "Monthly":"شهريا",
  "Yearly" :"سنوي",
  "Hosting Plans":"خطط الاستضافة",
  "SaaS Admin Signin": "تسجيل دخول مسؤول SaaS",
  "Password": "كلمة المرور",
  "Remember me": "تذكرني",
  "Enter your email": "أدخل بريدك الإلكتروني",
  "Enter your password": "أدخل كلمة المرور",
  "Log In": "تسجيل الدخول",
    "Please Fill all the fields": "الرجاء ملء جميع الحقول",
    "Heading is required.":"العنوان مطلوب.",
    "Theme has been updated successfully":"تم تحديث الثيم بنجاح",
    "Plan has been updated successfully":"تم تحديث الخطة بنجاح",

};

export default ar;
